export default __webpack_public_path__ + "static/media/logo192x192.00d988a8.png";